import { ChangeDetectionStrategy, Component, ElementRef, inject, output } from '@angular/core';
import { map } from 'rxjs/operators';
import { toSignal } from '@angular/core/rxjs-interop';
import { ActivitySectionDirective, SpecialsService, UserActivityClickTrackingDirective } from '@core';
import { SwiperContainerComponent } from '@core/lib/components/swiper/swiper-container.component';
import { SwiperSlideComponent } from '@core/lib/components/swiper/swiper-slide.component';
import { LoadingComponent } from '@app/components/loading/loading.component';
import { PageHeaderBackSwipeConfig, PageHeaderComponent } from '@app/components/page-header/page-header.component';
import { SwiperVideoControlDirective } from '@core/lib/components/swiper/swiper-video-control.directive';

@Component({
  selector: 'app-promos',
  templateUrl: './promos.component.html',
  styleUrls: ['./promos.component.scss'],
  host: {
    'class': 'page',
  },
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    ActivitySectionDirective,
    LoadingComponent,
    SwiperContainerComponent,
    SwiperSlideComponent,
    PageHeaderComponent,
    PageHeaderComponent,
    UserActivityClickTrackingDirective,
    SwiperVideoControlDirective,
  ],
})
export class PromosComponent {

  private readonly specialsService = inject(SpecialsService);
  private readonly elementRef = inject<ElementRef<HTMLElement>>(ElementRef);

  protected readonly backSwipeConfig: PageHeaderBackSwipeConfig = {
    direction: 'vertical',
    element: this.elementRef.nativeElement,
  };

  private readonly specials$ = this.specialsService.specials$.pipe(
    map((specials) => {
      return specials?.filter(special => !special.name.startsWith('['));
    }),
  );

  public readonly specials = toSignal(this.specials$);

  public readonly loading = toSignal(this.specialsService.loading$, {
    initialValue: true,
  });

  public readonly back = output();

}
